import React, { useState, useEffect } from "react";
import i18n from "../i18n.js";
import { Link, useLocation, useParams } from "react-router-dom";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { Alert } from "@mui/material";

const FromForm = (props) => {
    const { itemOptions, hobby } = props;
    const { t } = i18n;
    const { comp, user } = itemOptions;
    let isSolo = false;
    let isCouple = false;
    let isTeam = false;
    let { code: tmpCode } = useParams();
    const [code, setCode] = useState("");
    let { state } = useLocation();
    useEffect(() => {
        if (!hobby) {
            setCode(state.code);
        } else {
            setCode(tmpCode);
        }
    }, []);

    comp.categoriesAll.forEach((cat) => {
        if (cat.subtype.solo === true) {
            isSolo = true;
        }
        if (cat.subtype.team === true) {
            isTeam = true;
        }
        if (cat.subtype.couple === true) {
            isCouple = true;
        }
    });

    const isClub = user?.clubs && user.clubs.length > 0;

    return (
        <React.Fragment>
            <hr />
            <h2 className="display-6 mt-2">{(!hobby && t("reg.from_form")) || (hobby && t("reg.from_form_hobby"))}</h2>
            <p>{t("reg.wdsf.choose_type")}</p>
            {hobby && !isClub && <Alert severity="warning">{t("reg.info.clubs_only")}</Alert>}

            {(!hobby || (hobby && isClub)) && (
                <Stack direction="row" spacing={2} sx={{ alignItems: "center", justifyContent: "center" }}>
                    {isSolo && (
                        <Link to="/formSolo" state={{ code: code, hobby: hobby }}>
                            <Button variant="contained" size="large">
                                {t("reg.wdsf.solo")}
                            </Button>
                        </Link>
                    )}
                    {!isSolo && (
                        <Button variant="contained" size="large" disabled>
                            {t("reg.wdsf.solo")}
                        </Button>
                    )}
                    {isCouple && (
                        <Link to="/formCouple" state={{ code: code, hobby: hobby }}>
                            <Button variant="contained" size="large">
                                {t("reg.wdsf.couple")}
                            </Button>
                        </Link>
                    )}
                    {!isCouple && (
                        <Button variant="contained" size="large" disabled>
                            {t("reg.wdsf.couple")}
                        </Button>
                    )}
                    {isTeam && !hobby && (
                        <Link to="/formTeam" state={{ code: code }}>
                            <Button variant="contained" size="large">
                                {t("reg.wdsf.team")}
                            </Button>
                        </Link>
                    )}
                    {!isTeam && !hobby && (
                        <Button variant="contained" size="large" disabled>
                            {t("reg.wdsf.team")}
                        </Button>
                    )}
                </Stack>
            )}
        </React.Fragment>
    );
};

export default FromForm;
